import { stringifyFilter } from "./queryUtils";

export const StatusCode = {
    IMPORTED_WITHOUT_FINDINGS: 1008,
    IMPORTED_WITH_FINDINGS: 1009,
    DELETED_WITHOUT_FINDINGS: 1018,
    DELETED_WITH_FINDINGS: 1019,
};

export function getStatusCode(statusCode) {
    return StatusCode[statusCode];
}

export function checkIfHaveFindings(statusCode) {
    switch (statusCode) {
        case 1008:
        case 1018:
            return false;
        default:
            return true;
    }
}

export const finalStatus = ["imported", "error", "invalid"];

export function generateFindingColumn(statusCode, status, I18n, fiscalYear, id) {
    const hasFindings = checkIfHaveFindings(statusCode);
    if (status === "imported") {
        return hasFindings
            ? {
                  label: "hasFindings",
                  value: {
                      id: "ncAudit",
                      color: "yellow",
                      name: I18n.translate`Yes`,
                      __typename: "AuditNavigation",
                      customParam: { fiscalYear: `${fiscalYear}`, importId: `${id}` },
                  },
                  type: "colorize-link",
              }
            : {
                  label: "hasFindings",
                  value: {
                      color: "green",
                      name: I18n.translate`No`,
                  },
                  type: "colorize-link",
              };
    } else {
        return hasFindings && finalStatus.includes(status)
            ? {
                  label: "hasFindings",
                  value: {
                      id: "ncAudit",
                      color: "yellow",
                      name: I18n.translate`Yes`,
                      __typename: "AuditNavigation",
                      customParam: { importId: `${id}` },
                      link: {
                          to: `/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear/full/nc_audit/unknown/audit_findings?filter=${stringifyFilter(
                              [{ column: "ID", filters: [{ value: `${id}` }] }],
                          )}`,
                      },
                  },
                  type: "colorize-link",
              }
            : {
                  label: "hasFindings",
                  value: finalStatus.includes(status)
                      ? {
                            color: "green",
                            name: I18n.translate`No`,
                        }
                      : {
                            name: "-",
                        },
                  type: "colorize-link",
              };
    }
}
